// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__2DnVW","topBottomGutter":"Layout_topBottomGutter__3VRNv"};